import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shouldShowConsentBanner, acceptAll, rejectAll, pixelConfigured } from '../services/consent'
import PolicyLink from './PolicyLink'

export default function CookieConsent() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(() => shouldShowConsentBanner())

  if (!visible) return null

  function choose(fn) {
    fn()
    setVisible(false)
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="consent-title"
      data-testid="cookie-consent"
      className="fixed inset-0 z-[65] flex items-center justify-center bg-black/50 px-6"
    >
      <div className="w-full max-w-sm rounded-card bg-surface p-7 text-center shadow-card">
        <p id="consent-title" className="text-lg font-bold text-fg">
          {t('consent.title')}
        </p>
        <p className="mt-2 text-sm leading-relaxed text-muted">
          {t(pixelConfigured ? 'consent.body' : 'consent.bodyAnalyticsOnly')}
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <button
            type="button"
            onClick={() => choose(acceptAll)}
            className="w-full rounded-card bg-primary px-4 py-3 text-sm font-semibold text-on-primary"
          >
            {t('consent.accept')}
          </button>
          <button
            type="button"
            onClick={() => choose(rejectAll)}
            className="w-full rounded-card border border-line px-4 py-3 text-sm font-semibold text-fg"
          >
            {t('consent.reject')}
          </button>
        </div>
        <PolicyLink
          to="/privatnost"
          className="mt-4 inline-block text-xs text-faint underline underline-offset-2"
        >
          {t('consent.more')}
        </PolicyLink>
      </div>
    </div>
  )
}
